import type { CommunityDetail } from 'models';
import { useTranslation } from 'react-i18next';
import { Form, FormActions, Modal, RichTextInput } from 'ui';
import { useUpdateCommunityMutation } from '../../../queries';

type FormValues = {
  description: string;
  htmlDescription: string;
};

type P = {
  community: CommunityDetail;
  isOpened: boolean;
  onClose: () => void;
};

const EditModal = ({ community, isOpened, onClose }: P) => {
  const { t } = useTranslation();
  const { isPending: isUpdatingCommunity, mutate: updateCommunity } = useUpdateCommunityMutation();

  const onFinish = (values: FormValues) => {
    updateCommunity(
      {
        data: { description: values.description, htmlDescription: values.htmlDescription },
        id: community.id,
      },
      {
        onSuccess() {
          onClose();
        },
      },
    );
  };

  return (
    <Modal
      isOpened={isOpened}
      onCancel={() => {
        onClose();
      }}
      title="Edit Description"
      width="large"
    >
      <Modal.HugContent>
        <Form<FormValues>
          initialValues={{ description: community.description, htmlDescription: community.htmlDescription }}
          onFinish={onFinish}
        >
          <RichTextInput
            html={{
              label: 'Description',
              name: 'htmlDescription',
            }}
            text={{ name: 'description' }}
          />
          <Modal.HugContent.Footer>
            <FormActions
              right={{
                children: t('Close'),
                onClick() {
                  onClose();
                },
              }}
              submit={{
                children: t('Save'),
                id: 'edit-community-description-btn',
                loading: isUpdatingCommunity,
              }}
            />
          </Modal.HugContent.Footer>
        </Form>
      </Modal.HugContent>
    </Modal>
  );
};

export default EditModal;
